module.exports = __webpack_public_path__ + "assets/img/b9eee642ac4ebf101da7d6c4e9759727.png";